/** THIS CONTAINS ALL WORDS THAT ARE CONSIDERED STATICALLY PRESENT IN THE APP, DYNAMICALLY ADDED CONTENTS WILL NOT BE HANDLED **/
export default {
  'app.loading': 'Finishing up some processes...',
  'app.logout': 'Logging out...',
  'auth.unauthorized':
    'Your session has timed out. Please log back in to complete this process.',
  'auth.unauthorized-special-feature':
    'You have to be logged in to continue using this feature.',

  //NavBar
  'nav.profile': 'Profile',
  'nav.edit-profile': 'Edit Profile',
  'nav.my-classrooms': 'My Classrooms',
  'nav.settings': 'Settings',
  'nav.logout': 'Logout',
  'nav.home': 'HOME',
  'nav.classrooms': 'CLASSROOMS',
  'nav.educators': 'EDUCATORS',
  'nav.sign-in': 'SIGN IN',
  'nav.sign-up': 'SIGN UP',
  'nav.apply': 'APPLY AS AN EDUCATOR',
  'nav.site-language': 'Site Language',

  //Home
  'home.hero-typo-1': 'Introducing',
  'home.hero-typo-2': 'A New Level of Experience',
  'home.hero-typo-3': 'In Learning And Teaching Languages',
  'home.hero-typo-4': 'Through Online Classrooms',
  'home.hero-option-1': '1. Learn different languages.',
  'home.hero-option-2': '2. Communicate with different people.',
  'home.hero-option-3': '3. Teach the language you love.',
  'home.hero-cta': 'The Features We Offer',
  'home.features': 'Our Features',
  'home.feature-1': 'Bringing Traditional Classroom Experience Online',
  'home.feature-1-1':
    'Along with the proliferation of language learning web apps comes various studies conducted in assessing their efficacy. Most of the results\n' +
    'often point to either lack of communicative support or grounds that a main stream or traditional classroom experience supports. In InteReact, we\n' +
    'tried our best to emulate the physical classroom experience.',
  'home.feature-2': 'Free For All',
  'home.feature-2-2':
    'InteReact is committed to making its platform practically accessible to everyone.\n' +
    'As such, we take pride in our Free For All Policy that states payment is not required unless agreed upon by both parties - students and educator.\n' +
    'If you wish you to know more about our Free For All Policy including the Payment Terms of Service, click',
  'home.feature-2-link': 'here.',
  'home.feature-3': 'Closely Monitored',
  'home.feature-3-3':
    'To ensure the digital safety and privacy of our users, we closely monitor activities and deal with violators\n' +
    'of our terms and policies immediately. We strongly condemn behavior that promotes Nudity, Violence, and Hate Speech.',
  'home.feature-4': 'Learn At Your Own Pace',
  'home.feature-4-4':
    'Bringing the classroom experience online still incurs the advantage of learning the lessons at your own pace and time.',

  //NOT FOUND
  'notfound.desc':
    "Looks like the page you are looking at is missing. Don't worry though, our explorer is on the case.",
  'notfound.redirectmsg': "For the meantime, why don't you head back home?",
  'notfound.btntext': 'Back Home',

  //Error Messages
  'login.user-banned':
    'The user associated with this account has been banned by our regulators.',
  'login.user-banned-contact-support':
    'If you believe the action has been done by mistake and wish to lift the ban, please have a chat with us.',
  'login.user-banned-link': 'Contact Support Now',
  'login.credentials-unmatched':
    'The email and password you entered do not match our records.',
  'login.invalid-password-length': 'Password should have 6 or more characters.',
  'signup.invalid-password-length': 'Password should have 6 or more characters.',
  'login.email-invalid': 'Email is invalid.',
  'signup.email-invalid': 'Email is invalid.',
  'signup.passwords-unmatched': "Passwords don't match.",
  'signup.email-exists':
    'The email you entered is already in our records. Please enter a different one.',
  'server.unexpected-error': 'Oops! An unexpected error occurred.',

  //Footer
  'footer.languages-available': 'Languages',
  'footer.about-intereact': 'About InteReact',
  'footer.legal-terms': 'Legal Terms',
  'footer.survey': 'Take the survey',
  'footer.contact': 'Have a question?',
  'footer.about-content':
    'InteReact is a free language learning service that caters to all kinds of learners. This application aims to serve as an exclusive portal for language learning and teaching through the use of digital classrooms. The project is created in fulfillment of the requirements for the Degree of Bachelor of Science in Computer Science.',
  'footer.about-read': 'Read more',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.cookies': 'Free For All Policy',
  'footer.survey-explanation':
    'This survey covers areas like convenience level, satisfaction rate and variation from other language learning apps. However, the efficiency of this language learning setting in terms of how much knowledge a student learns in some time will not be covered.',
  'footer.answer-survey': 'Answer survey',

  //How To Apply
  'how-to-become-educator': 'How can I become an educator of InteReact?',
  'how-to-professional': 'Professional Teaching Profile',
  'how-to-native': 'Native Speakers Who Like To Teach',
  'how-to-bitriprof': 'Bilingual or Multilingual Proficiency',
  'how-to-user-type': 'Register as Educator',
  'how-to-user-type-desc':
    'Signing up as an educator is required for the administrators to successfully verify your account as permitted to teach.',
  'how-to-professional-desc':
    'The fastest way to be accepted as an educator and start creating your first classroom is to provide a written document showing your training and experience as an educator. ' +
    'A person who is certified to teach or is already teaching a language professionally may qualify for a professional teaching profile on InteReact.',
  'how-to-native-desc':
    'Native speakers who want to teach their language can also apply for verification. You can either send a video showing at least that you are proficient enough to your second language.' +
    'Sending a personal e-mail stating your purpose to join is also possible. In InteReact, we are open to those language lovers who want to share their linguistic skills to everyone for free.',
  'how-to-bitriprof-desc':
    'Proving that you can speak at least 2 languages is ideal to have your application verified.',
  'how-to-send-email': 'Send an e-mail to InteReact',
  'how-to-send-email-desc': 'Send an e-mail to InteReact',

  //HomeGen
  'homegen.headings': 'Fluency Through Language Exposure',
  'homegen.headings-button': 'Learn more',
  'homegen.main-intro':
    'Language always carries meaning and references beyond itself. The meanings of a particular ' +
    'language represent the culture of a particular social group. In InteReact, we believe that language learning is ' +
    'not solely to learn and memorize complex grammar rules and hard word spellings but also opens up the door to comprehend the behavior ' +
    'of the society and its cultural customs.',
  'homegen.why-learn-a-language':
    'Through the Communicative Language Teaching approach deployed by the use of online classrooms, you can interact with other students and your educator while learning the language. ' +
    'Other pedagogical approaches to language learning can be utilized too depending on the educator, however, regardless of the approach to teaching, studying a language in InteReact would be fun because of its interactive ecosystem. ' +
    'Each classroom can only cater to at least 50 students, thus, limiting the environment to a small ecosystem.',
  'homegen.middle-block-headings': 'Speak more than one language',
  'homegen.middle-block-icon-1': 'Learn a language',
  'homegen.middle-block-icon-2': 'Talk to our educators',
  'homegen.middle-block-icon-3': 'Talk in the classroom',
  'homegen.features-text': 'Features',
  'homegen.features-title-1': 'All Free',
  'homegen.features-title-2': 'Dedicated Classroom',
  'homegen.features-title-3': 'Proof of Completion',
  'homegen.features-title-4': 'Live Lecture',
  'homegen.features-title-5': 'Interactive',
  'homegen.featues-title-desc-1':
    'No payment wall hinders your desire to learn a language whether be it a hobby or professional reasons. Educators ' +
    'are free to teach any time they like or during their free time. Many thanks to those who would share some or even a little of their time to teach a language for free.',
  'homegen.featues-title-desc-2':
    'Each classroom caters to up to 50 students and 1 educator. Educators can even start the classroom even with only 5 students enrolled, thus, a small yet interactive ecosystem for all.',
  'homegen.featues-title-desc-3':
    'A digital certificate of completion will also be given after the educator marks the class as finished. A link will be given which will you can share to everyone!',
  'homegen.featues-title-desc-4':
    'Educators can host a live lecture for free, yet it could be limited due to issue on resources. Regardless, learning would be much more fun in real time!',
  'homegen.featues-title-desc-5':
    'Classrooms have a Lecture, Assignment, Chat, Stream-like and Calendar Pages built-in to facilitate a continuous communication. Chatting will still be possible even with finished classes!',

  //ClassroomsGen
  'classroomsgen.headings': 'Classrooms',
  'classroomsgen.cbox-educ-text': 'Educator',
  'classroomsgen.cbox-lang-spoken-text': 'Languages Spoken',
  'classroomsgen.cbox-btn-text': 'Join Now',
  'classroomsgen.cbox-helper-icon-msg':
    'Educators cannot join classrooms and students can only join up to 1 classroom.',
  'classroomsgen.students-enrolled': 'Students Enrolled',
  'classroomsgen.students-noenrolled': 'No students currently enrolled',
  'classroomsgen.students-enroll': 'Enroll',
  'classroomsgen.joining': 'Enrolling in the class...',
  'classroom.error-full': 'Classroom Full',
  'classroom.error-email-unverified':
    'The e-mail address associated to your account is not verified. Please send a verification email.',
  'classroom.error-full-desc': 'Fifty students are already enrolled in the class.',
  'classroom.error-active': 'Active Classroom Detected',
  'classroom.error-active-desc':
    'Only one classroom can be enrolled at a time. If it is still possible, you can still un-enroll to the current one by going to the classroom page. You can re-enroll after the current one is set to finished.',
  'classroom.success-join': 'Successfully Joined',
  'classroom.success-join-desc':
    'Congratulations! You have enrolled in the classroom. Please take a moment to refresh the application.',
  'classroom.go-to-classroom-page': 'Go to Classroom',

  //Educators
  'educators.filter-by-nationality': 'Nationality',
  'educators.filter-by-language': 'Also speaks',
  'educators.search-by-name': 'Search educators by their names',
  'educators.apply-filter': 'Apply filter',
  'educators.educators-found-text': 'educators found',
  'educators.educators-found-text-singular': 'educator found',
  'educators.educators-no-rating': 'No rating',
  'educators.educators-speaks': 'Speaks',
  'educators.educators-description': 'Description',
  'educators.educators-gender-empty': 'No gender provided',
  'educators.educators-description-empty': 'No description provided',

  //SignIn
  'signin.welcome-msg': 'Welcome back!',
  'signin.email-field': 'E-mail',
  'signin.password-field': 'Password',
  'signin.remember-field': 'Remember me',
  'signin.forgot-field': 'Forgot Password',
  'signin.new-to-field': 'New to InteReact? Register an account.',
  'signin.terms-and-privacy': 'Terms of use. Privacy policy.',
  'signin.button': 'Sign In',
  'signin.modal-signing': 'Signing in...',
  'signin.error-email-existence': 'The e-mail is not linked to any account.',
  'signin.error-unmatch': "Password and e-mail don't match.",
  'signin.banned': 'This account is banned.',

  //Sign Up
  'signup.bg-headings-1': 'Learn and Test Your Linguistic Skills Today',
  'signup.bg-headings-2': 'Language Exposure | Fluency | Communicate',
  'signup.form': 'Come join us!',
  'signup.form-student': 'Sign Up as a Student',
  'signup.form-educator': 'Sign Up as an Educator',
  'signup.form-complete-msg': 'Please complete to create your account.',
  'signup.form-first-name': 'First Name',
  'signup.form-last-name': 'Last Name',
  'signup.form-username': 'Username',
  'signup.form-gender': 'Gender',
  'signup.form-gender-male': 'Male',
  'signup.form-gender-female': 'Female',
  'signup.form-email': 'Email',
  'signup.form-password': 'Password',
  'signup.form-confirm': 'Confirm Password',
  'signup.form-languages-spoken': 'Languages Spoken',
  'signup.form-language-already-chosen': 'You have already chosen that language.',
  'signup.form-language-not-supported': 'Language not supported',
  'signup.form-nationality': 'Nationality',
  'signup.form-agree-terms':
    "I agree with InteReact's terms of service and privacy policy.",
  'signup.form-see-terms': 'Terms of Service',
  'signup.form-see-policy': 'Privacy Policy',
  'signup.form-button': 'Sign Up',
  'signup.form-ahaa-signin': 'Already have an account? Sign in.',
  'signup.modal-signing': 'Creating account...',
  'sign-up.confirmation-needed':
    'By signing up, you must agree with our Terms of Service and Privacy Policy.',

  //ForgotPassword
  'forgotpassword.headings': 'Password Reset',
  'forgotpassword.reenter': 'Re-enter Email',
  'forgotpassword.send': 'Send a Link',
  'forgotpassword.invalid-email': 'Enter a valid e-mail address.',
  'forgotpassword.unmatch': "Emails don't match.",
  'forgotpassword.match-valid': 'E-mails are valid and matching.',
  'forgotpassword.unexisting': 'Email not associated to any account.',
  'forgotpassword.sent': 'Email has been sent.',
  'forgotpassword.emailheadings': 'Email Verification',
  'forgotpassword.unverified': 'Email Unverified',

  //CopyDialog Component
  'copy-dialog.title': 'Copy URL to Clipboard',
  'copy-dialog.description':
    "If the copy function doesn't work as expected, please copy the URL manually.",
  'copy-dialog.copied-text': 'URL has been copied to the clipboard.',
  'copy-dialog.agree': 'Copy',
  'copy-dialog.disagree': 'Close',

  //All Classrooms
  'all-classrooms.classroom-name': 'Classroom Name:',
  'all-classrooms.classroom-description': 'Classroom Description:',
  'all-classrooms.view-classroom': 'View Classroom',
  'all-classrooms.join-classroom': 'Join Classroom',
  'all-classrooms.dialog-agree': 'Agree',
  'all-classrooms.dialog-disagree': 'Disagree',
  'all-classrooms.dialog-description':
    'You will leave the Classrooms page and be redirected to another page.',
  'all-classrooms.dialog-title': 'View full classroom details?',
  'all-classrooms.report-classroom': 'Report Classroom',
  'all-classrooms.rated by': 'Rated by',
  'all-classrooms.users': 'users',
  'all-classrooms.no-results': 'Showing no results for the filters:',
  'all-classrooms.no-results-status': 'Classroom Status',
  'all-classrooms.no-results-status-available': 'Available',
  'all-classrooms.no-results-status-ongoing': 'Ongoing',
  'all-classrooms.no-results-status-completed': 'Completed',
  'all-classrooms.view-more-classrooms': 'View More Classrooms',
  'all-classrooms.clear-filters': 'Clear Filters',
  'all-classrooms.apply-filter': 'Apply Filter',
  'all-classrooms.search-placeholder': 'Search by classroom name',

  //All Educators
  'all-educators.full-name-not': 'Full name not provided',
  'all-educators.gender-not': 'Gender not provided',
  'all-educators.description-not': 'Description not provided',
  'all-educators.users-who-evaluated': 'users have rated this educator.',
  'all-educators.report': 'Report Educator',
  'all-educators.view-more-educators': 'View More Educators',
  'all-educators.search-placeholder': 'Search by educator name',
  'all-educators.no-results-search-string': "Educator's Name",

  //Classroom View
  'classroom.not-exist': 'There is nothing here. The classroom might have been deleted.',
  'classroom.user-is-creator': 'You are the creator.',
  'user-id.not-found': 'This account might have been deleted.',
  'classroom.checking-status': 'Checking status',
  'classroom.joining-success-welcome': 'Welcome to your new classroom!',
  'classroom.share-link-description':
    'Language learning is more fun with a lot of people. Your friends can join too and learn together with you!',
  'classroom.joining-challenged': 'Validation Challenge',
  'classroom-join.credentials-required':
    'Full name, nationality and languages spoken are required before you can join a classroom. Make sure to provide all the fields first.',
  'email.unverified': 'Verify your email address first.',
  'classroom-join.joined-already': 'You have already joined this classroom.',
  'classroom-join.started-already': 'The classroom has already started.',
  'classroom-join.ended-already': 'The classroom has already been completed.',
  'classroom-join.classroom-not-exist':
    'The classroom has been deleted. Please refresh the page.',
  'classroom-join.limit-reached':
    'Classroom is already full. Only 50 students per classroom are allowed to join.',
  'classroom-status.completed': 'CLASSROOM COMPLETED!',
  'classroom-status.started': 'CLASSROOM STARTED ALREADY!',
  'classroom-status.full': 'CLASSROOM FULL!',
  'classroom-status.open': 'SLOTS ARE STILL OPEN!',
  'classroom-view.go-to-classroom': 'Go to classroom',
  'classroom-view.sign-in-to-join': 'Sign in to join',
  'classroom-view.about-creator-label': 'About the Creator:',
  'classroom-view.powered-by': 'Powered By',
  'classroom-view.translate-from': 'Translate text from 68 available languages.',
  'classroom-view.translate-to': 'Translate to',
  'classroom-view.translation': 'Translation',
  'classroom-view.translated-from': 'Translated from',
  'classroom-view.creator-info': 'Creator Info',

  //Classroom Edit
  'form.edit-classroom': 'Edit Classroom Details',
  'form.editing-classroom': 'Editing Classroom',
  'form-editing-classroom-success': 'Classroom details have been updated!',
  'classroom-validate.not-exist': 'Classroom is not found. It might have been deleted.',
  'classroom-validate.completed-already':
    'This action is no longer allowed as the classroom is already completed.',
  'classroom-validate.not-creator':
    'Forbidden! You might be lost. Please take a step back.',

  //User Inputs Errors
  'input-errors-required': 'This field is required.',
  'input-errors-first-name-errlength':
    'First name should be between 2 to 32 characters only.',
  'input-errors-last-name-errlength':
    'Last name should be between 2 to 32 characters only.',
  'input-errors-email-invalid': 'This e-mail is invalid.',
  'input-errors-password-errlength': 'Password has to contain at least 6 characters.',
  'input-error-username-empty': 'Username should not be empty.',
  'input-error-username-alphanumeric': 'Username contains invalid characters.',
  'input-error-username-allnumbers': 'Username should also contain letters.',
  'input-error-full-name-empty': 'Full name should not be empty.',
  'input-error-full-name-errlength':
    'Full name should be between 4 to 64 characters only.',
  'input-error-description-empty': 'Description should not be empty.',
  'input-error-description-errlength':
    'Description has to define you well, thus, we believe it should contain between 32 to 1024 characters.',
  'input-error-languages-empty': 'Languages spoken should not be empty.',
  'input-error-cname-errlength':
    'Classroom name should be between 4 to 64 characters only.',
  'profile.classroom-educator-unverified':
    'Verification is needed to create a classroom. See the qualifications on how to apply as an educator.',
  'profile.classroom-see-how': 'See how',

  //UserMeEdit
  'user-me-edit.languages-placeholder': 'Add a language',
  'user-me-edit.nationality-placeholder': 'Choose your nationality',
  'user-me-edit.gender-placeholder': 'Add gender',
  'user-me-edit.edit-btn': 'Edit My Details',
  'user-me-edit.editing-btn': 'Updating your details...',
  'user-me-edit.profile-updated': 'Your profile has been successfully updated.',
  'user-me-edit.apply-btn': 'Apply as Educator',
  'user-me-edit.delete-tooltip': 'Delete Image',
  'user-me-edit.upload-btn': 'Upload Image',
  'user-me-edit.change-btn': 'Change Image',

  //Profile
  'profile.add-classroom': 'Add Classroom',
  'profile.edit-profile': 'Edit Profile',
  'profile.join-classroom': 'Join Classroom',
  'profile.classrooms-list': 'Classrooms',
  'profile.helper-modal-classrooms-what': 'What are these images?',
  'profile.helper-modal-classrooms-done':
    'This image will show classrooms which are already marked as finished.',
  'profile.helper-modal-classrooms-current':
    'This image will show the current active classroom.',
  'profile.by-educator': 'by',
  'profile.description': 'DESCRIPTION',
  'profile.send-message': 'Send a message',
  'profile.full-name': 'Full Name',
  'profile.position': 'Position',
  'profile.occupation': 'Occupation',
  'profile.birthday': 'Birthday',
  'profile.gender': 'GENDER',
  'profile.username': 'Username',
  'profile.change-avatar': 'Change Avatar',
  'profile.size-limit': 'Up to 10MB Limit',
  'profile.upload': 'Upload',
  'profile.languages-spoken': 'LANGUAGES SPOKEN',
  'profile.nationality': 'NATIONALITY',
  'profile.modal-headings': 'New Classroom',
  'profile.modal-cname': 'Classroom Name',
  'profile.modal-cstarts': 'Start of Classes',
  'profile.modal-tlanguage': 'Target Language',
  'profile.modal-days-from-sing': 'day from now',
  'profile.modal-days-from-plu': 'days from now',
  'profile.modal-input-placeholder': 'Type the classroom name here.',
  'profile.modal-button-cancel': 'Cancel',
  'profile.modal-button-create': 'Create',
  'profile.edit-add-language': 'Add a language here',
  'profile.edit-modal-changes': 'The following fields will be changed.',
  'profile.edit-modal-proceed': 'Proceed',
  'profile.edit-modal-loader-editing': 'Editing profile...',
  'profile.edit-modal-success': 'User profile has been successfully updated.',
  'profile.edit-modal-failure': 'Editing profile failed.',
  'profile.classroom-created': 'Classroom is successfully created!',
  'profile.classroom-failed':
    'Only one active classroom per educator is allowed. If you wish to create a new one, set the current active classroom to finished.',
  'profile.edit-languages-spoken': "Now's the time to showcase your linguistic skills",
  'profile.edit-gender': 'Edit gender',
  'profile.edit-nationality': 'Edit nationality',
  'profile.edit-fullname': 'Add your full name',
  'profile.edit-description': 'Show them your thoughts',
  'profile.nav-home': 'Home',
  'profile.nav-classrooms': 'My Classrooms',
  'profile.nav-edit-profile': 'Edit Profile',
  'profile.nav-create-classroom': 'Create Classroom',
  'profile.edit': 'Edit',
  'profile.avatar-upload-failed': 'Failed uploading profile image. Please try again.',
  'profile.avatar-upload-size-exceeded': 'Image cannot be more than 10 MB.',
  'profile.avatar-upload-success':
    'Avatar has been successfully updated. Please refresh the page to see changes.',
  'nsfw.violated':
    'The image you uploaded has fallen in either one of the categories: Nudity, Offensive, Alcohol, Drugs, Weapons and Minors.',

  //Other Profile
  'other-profile.name-not-added': 'This user has not added a name yet.',
  'other-profile.languages-spoken-not-added': 'This user has not added any language yet.',
  'other-profile.nationality-not-added': 'Not added yet',
  'other-profile.gender-not-added': 'Not added yet',
  'other-profile.description-not-added': 'This user has not added a description yet.',
  'other-profile.nav-go-to-profile': 'My Profile',
  'other-profile.banned-icon-tooltip':
    'This user is currently banned by the administrators.',
  'other-profile.verified-icon-tooltip':
    "This user's educator profile is approved and manually reviewed by our regulators.",
  'other-profile.proof-of-skill-label': 'PROOF OF SKILL LEVEL',
  'other-profile.educator-ratings': 'EDUCATOR RATINGS',
  'other-profile.user-no-review': 'The user did not leave a review.',
  'other-profile.review-label': 'Review',

  //Settings
  'settings.option-1': 'Account Basics',
  'settings.option-2': 'Email Notifications',
  'settings.option-3': 'Privacy',
  'settings.six-digit-placeholder': 'Enter the code we sent through your new email',
  'settings.six-digit-error': 'Enter 6 digit code only.',
  'settings.verify-code': 'Verify Code',
  'settings.current-email': 'Current E-mail',
  'settings.current-email-placeholder': 'Enter your current email address',
  'settings.new-email': 'New E-mail',
  'settings.new-email-placeholder': 'Enter the new email address',
  'settings.change-email': 'Change Email',
  'settings.email-verified-notice':
    'The email address in your account has already been verified.',
  'settings.to-join-notice':
    'To join classrooms, you will have to verify your email address first.',
  'settings.resend-email-notice': 'You can re-send verification after 1 minute.',
  'settings.verify-now': 'Verify Now',
  'settings.verification-sent': 'Verification request has been sent to your email.',
  'settings.email-verification': 'Email Verification',
  'settings.change-email-address': 'Change Email Address',
  'settings.current-email-address': 'Current E-mail Address:',
  'settings.classroom-notifications': 'Classroom Notifications',
  'settings.toggle-notifications':
    'Receive classroom notifications through my email address.',
  'settings.untoggle-notifications':
    "I don't want to receive classroom-related notifications through my email.",
  'settings.notification-miss-warning':
    'Choosing this option would opt you out on any classroom related activities. You might miss out on lecture, assignment, or live stream updates.',
  'settings.email-language': 'Email Language',
  'settings.email-language-info':
    'This will change the language of the email you are receiving from us. Currently, we only support English and Italian.',
  'settings.save-language': 'Save Language',
  'settings.notification-updated': 'Your email notification preference has been updated!',
  'settings.preferred-updated': 'Preferred email language has been changed!',

  //My Classrooms
  'my-classrooms.tab-created': 'CREATED',
  'my-classrooms.tab-enrolled': 'ENROLLED',
  'my-classrooms.tab-archived': 'ARCHIVED',
  'my-classrooms.no-classrooms-to-teach':
    "You don't have any classroom to teach currently.",
  'my-classrooms.create-classroom': 'Create a Classroom Now',
  'my-classrooms.not-enrolled': 'You are not enrolled to any classroom yet.',
  'my-classrooms.join-classroom': 'Join a Classroom Now',
  'my-classrooms.no-completed': "You haven't completed any classroom yet.",
  'my-classrooms.active-classroom.created-at': 'Created At:',
  'my-classrooms.active-classroom.started-on': 'Classroom Started On:',
  'my-classrooms.active-classroom.starts-in': 'Classroom Starts In:',
  'my-classrooms.active-classroom.target-language': 'Language To Teach:',
  'my-classrooms.active-classroom.classroom-ratings': 'Classroom Ratings:',
  'my-classrooms.active-classroom.share-link': 'Share link',
  'my-classrooms.active-classroom.go-to-classroom': 'Go to classroom',
  'my-classrooms.active-classroom.view-your-profile': 'View your profile',
  'my-classrooms.active-classroom.view-user-profile': 'View user profile',
  'my-classrooms.active-classroom.report-user': 'Report this user',
  'my-classrooms.archived-table.classroom-name': 'Classroom Name',
  'my-classrooms.archived-table.target-language': 'Target Language',
  'my-classrooms.archived-table.creator': 'Creator',
  'my-classrooms.archived-table.date-started': 'Date Started',
  'my-classrooms.archived-table.date-finished': 'Date Finished',
  'my-classrooms.archived-table.certificates': 'Certificates',
  'my-classrooms.archived-table.view-certificate': 'View Certificate',
  'my-classrooms.number-of-raters': 'users have rated this classroom.',
  'my-classrooms.add-rating-btn': 'Add Rating',
  'my-classrooms.rating-title-form': 'Rating Form',
  'my-classrooms.rating-label': 'Rating',
  'my-classrooms.rating-save-btn': 'Save Rating',
  'my-classrooms.rating-saved': 'Your rating has been saved!',
  'my-classrooms.comment-label': 'Comment (Optional)',
  'classroom-creator-or-member.started-yet-insufficient':
    "Questa classe verrà eliminata entro il giorno a causa dell'insufficiente numero di studenti iscritti.",

  //Settings
  'email-change.email-exists':
    'The new email address you supplied is already in our records.',
  'email-change.email-same':
    'The new email address you supplied is already the same with your email in our records.',
  'email-change.email-unmatch':
    'The current email you supplied does not match the email you have in our records.',
  'email-change.email-invalid':
    'An anomaly has occurred. Please refrain from doing any suspicious activity!',
  'email-change.code-unmatch': 'The 6 digit code you entered do not match with our data.',
  'email-change.code-consumed': 'The 6 digit code you entered has already been used.',
  'email-change.code-expired': 'The 6 digit code you entered has already expired.',
  'email-change.success': 'Your email has been successfully changed!',
  'email-request.too-soon':
    'Please wait for a minute before requesting another verification.',
  'email-request.user-already-verified':
    'Your email has already been verified. Please refresh the page.',

  //Email Verify
  'verification-token.validating': 'Validating Token',
  'verification-token.success': 'Your email has been verified!',
  'verification-token.invalid':
    'The token is invalid. It is possible that it has already been consumed or expired.',

  // Reset Password & Verify
  'reset-password.password-label': 'Password',
  'reset-password.re-password-label': 'Confirm Password',
  'reset-password.password-insufficient':
    'Password should contain at least 6 characters.',
  'reset-password.passwords-not-matching': "The passwords don't match.",
  'reset-password.reset-btn': 'Reset Password',
  'reset-password.changing-failed': 'Changing password has failed!',
  'reset-password.changing-success': 'Your password has been changed!',
  'reset-password.sent-instructions':
    "We have sent instructions on how to reset your password on your email. If you haven't received one yet, please make sure you have entered the correct email.",
  'reset-password.email-sending-failed':
    'Sending request has failed. Please refresh the page and retry the process.',
  'reset-password.request-password-reset-btn': 'Request for Password Reset',

  //General Position Localized
  'profile.educator': 'Educator',
  'profile.student': 'Student',
  'profile.m': 'Male',
  'profile.f': 'Female',
  'profile.M-educator': 'Educator',
  'profile.F-educator': 'Educator',
  'profile.M-student': 'Student',
  'profile.F-student': 'Student',

  //Create Classroom
  'user.not-eligible':
    'It seems that you are not allowed to create a classroom due to the following reasons:',
  'user.not-educator-status':
    'To know more of the complete application process, please see this link: ',
  'user.see-more-application-process-link': 'How to apply as an educator?',
  'user.not-email-verified':
    'You have to verify the e-mail address you use in your account.',
  'user.verify-link': 'Verify now',
  'user.not-educator-verified':
    'You have to send an application request which will then be reviewed by our staff.',
  'user.send-application-link': 'Send application request now',
  'user.reached-classrooms-limit':
    'You can only have three (3) ongoing classrooms to control the number of created classrooms each day.',
  'user.set-classroom-complete-link': 'How to set classroom as completed?',
  'form.classroom-name': 'Classroom Name',
  'form.classroom-name-error': 'Classroom Name should contain 6 to 128 characters only.',
  'form.starting-date': 'Starting Date',
  'form.starting-date-error': 'Starting date should be 1 - 30 days from now.',
  'form.target-language': 'Target Language',
  'form.target-language-placeholder': 'Select a language to teach.',
  'form.target-language-error': 'You should specify the language that you will teach.',
  'form.classroom-description-placeholder': 'Why should they join your classroom?',
  'form.classroom-description-error': 'Description should contain 32 to 4096 characters.',
  'form.creating-classroom': 'Creating Classroom',
  'form.create-classroom': 'Create Classroom',
  'form.create-classroom-success': 'Classroom Creation Success!',
  'form.create-classroom-success-description':
    "To make the most out of your classroom teaching experience, here's a guide on",
  'form.create-classroom-success-link':
    'Maximizing the Use of the Rich Text Editor in Creating Classroom Lectures and Assignments.',

  //Classroom Nav
  'classroom-nav.title': 'Classroom Portal',
  'classroom-nav.leave-portal': 'Leave Portal',
  'classroom-nav.lectures': 'Lectures',
  'classroom-nav.assignments': 'Assignments',
  'classroom-nav.chat': 'Chat',
  'classroom-nav.live-stream': 'Live Stream',
  'classroom-nav.events': 'Events',
  'classroom-nav.help-center': 'Help Center',
  'classroom-nav.settings': 'Classroom Settings',
  'classroom-nav.leaving-dialog-agree': 'Leave',
  'classroom-nav.leaving-dialog-disagree': 'Cancel',
  'classroom-nav.leaving-dialog-title': 'Are you sure you want to leave the portal?',
  'classroom-nav.leaving-dialog-description':
    'You will be redirected back to your list of classrooms.',
  'classroom-me.modal-headings': 'Classroom has not started yet!',
  'classroom-me.modal-settings-btn': 'Go to Settings',
  'classroom-me.modal-descriptions':
    "We're showing this modal to remind you that the classroom has not started yet.\n" +
    'Only you as the classroom creator can enter the Classroom Portal at this time.\n' +
    'You have the option to manually start through the Classroom Settings.\n' +
    'At least 1 classroom student should be enrolled to start manually.',
  'classroom-member.not-started': 'The classroom has not started yet.',

  //Report Form
  'report-form.user-dialog-title': 'User Violation Report Form',
  'report-form.lecture-dialog-title': 'Lecture Violation Report Form',
  'report-form.chat-dialog-title': 'Chat Violation Report Form',
  'report-form.assignment-dialog-title': 'Assignment Violation Report Form',
  'report-form.bug-dialog-title': 'Application Bugs Report Form',
  'report-form.classroom-dialog-title': 'Classroom Violation Report Form',
  'report-form.violation-label': 'Violation Type',
  'report-form.helper-text-violation': 'Please select a violation.',
  'report-form.email-label': 'Email Address',
  'report-form.helper-text-email': 'Please enter an email where we can get back at you.',
  'report-form.description-label': 'Description',
  'report-form.helper-text-description': 'Please provide more details of the violation.',
  'report-form.button': 'Send Report',
  'report-form.submit-success': 'The report has been sent!',

  //Classroom Lectures
  'lectures.empty': 'No lectures posted yet. Stay tuned!',
  'lectures.form-title': 'Title',
  'lectures.form-schedule-helper': 'Advance Scheduling',
  'lectures.form-schedule-more-info':
    'The lecture will not be posted in the dashboard until the time you specified.',
  'lectures.form-schedule': 'Post In Advance (Optional)',
  'lectures.form-content-placeholder': 'Add lecture content here',
  'lectures.form-title-error': 'Title should contain 1 - 128 characters.',
  'lectures.form-advance-schedule-error': 'Chosen date should not be in the past.',
  'lectures.form-content-error-empty': "Lecture content can't be empty.",
  'lectures.form-content-error-exceeded':
    'Lecture content has exceeded 10000 characters. Be sure to check embedded URLs as they contain long texts.',
  'lectures.saving': 'Saving Lecture',
  'lectures.saving-success': 'Lecture has been saved!',
  'lectures.lecture-box-date-created': 'Date Created:',
  'lectures.lecture-box-date-updated': 'Last Updated:',
  'lectures.lecture-box-send-report': 'Report Lecture',
  'lectures.lecture-box-view-lecture': 'View Lecture',
  'lectures.speed-dial-add': 'Add',
  'lectures.speed-dial-save': 'Save',
  'lectures.app-bar-title': 'Add Lecture',
  'lectures.app-bar-button': 'Save Lecture',
  'lectures.set-advance-helper':
    'This is set to be posted in advance. Only you can see this.',

  // CommentsBlock Component
  'comments-block.comments': ' Comments',
  'comments-block.no-comments': "No comments yet. Why don't you start a conversation?",
  'comments-block.send-your-thoughts': 'Send your thoughts here',
  'comments-block.send-label': 'Your Comment',
  'comments-block.comment-empty': 'Comment cannot be empty.',
  'comments-block.comment-exceeded': '256 characters only. You have entered:',
  'lecture.not-exist': 'The lecture is not found.',

  // Lecture View
  'lecture.not-found': 'The lecture is not found.',
  'lecture.lecture-content': 'Lecture Content:',
  'translation.confidence-too-low':
    'Unable to automatically detect the source language, confidence too low.',
  'translation.translate-button': 'Translate',
  'lecture.breadcrumbs-lectures': 'Lectures',
  'lecture.app-bar-edit-title': 'Edit Lecture',
  'lecture.app-bar-edit-button': 'Save Changes',
  'lecture.editing-success': 'Lecture has been edited.',
  'lectures.editing': 'Lecture is currently being edited.',
  'lectures.delete-agree': 'Delete Now',
  'lectures.title-assurance-delete': 'Are you sure to delete the lecture?',
  'lectures.warn-before-delete':
    "This action is irrevocable. You won't be able to retrieve this lecture in the future.",
  'lectures.deleting': 'Currently deleting this lecture...',
  'lectures.deleting-success': 'The lecture has been deleted!',
  'lectures.deleting-error':
    'This is a rare error. Kindly refresh the page and retry action.',

  // Assignments
  'assignments.empty': 'Worry not! No assignment to submit yet.',
  'assignments.form-schedule-more-info':
    'The assignment will not be posted in the dashboard until the time you specified.',
  'assignments.form-submission-time': 'Submission Time (Optional)',
  'assignments.app-bar-title': 'Add Assignment',
  'assignments.app-bar-button': 'Save Assignment',
  'assignments.form-content-placeholder': 'Add assignment content here',
  'assignments.form-content-error-empty': 'Assignment content cannot be empty.',
  'assignments.form-content-error-exceeded':
    'Assignment content has exceeded 10000 characters. Be sure to check embedded URLs as they contain long texts.',
  'assignment-form.submission-past-advance':
    'Submission time should be ahead of scheduled posting.',
  'assignment-form.submission-time-past':
    'Submission time must be ahead of the current time.',
  'assignments.assignment-box-submission-time': 'Submission Time:',
  'assignments.assignment-box-no-submission': 'No Submission Date',
  'assignments.assignment-box-view-assignment': 'View Assignment',
  'assignments.assignment-box-send-report': 'Report Assignment',
  'assignments.assignment-box-send-deadline-warning':
    'You have less than a day to turn in your task.',
  'assignments.saving-success': 'The assignment has been saved in our server!',
  'assignments.saving': 'Saving assignment to our server...',

  // Assignment Creator View
  'creator-assignment-view.secure-page-info':
    'This is a secure page. Only you as the creator can see this.',
  'creator-assignment-view.assignments-breadcrumb': 'Assignments',
  'creator-assignment-view.edit': 'Edit Assignment',
  'creator-assignment-view.delete': ' Delete Assignment',
  'assignment.editing-success': 'Assignment has been edited.',
  'assignment.editing': 'Assignment is currently being edited.',
  'assignment.deleting': 'Currently deleting this assignment...',
  'assignment.deleting-success': 'The assignment has been deleted!',
  'assignment.title-assurance-delete': 'Are you sure to delete the assignment?',
  'assignment.warn-before-delete':
    "This action is irrevocable. You won't be able to retrieve this task in the future.",
  'assignment.not-found': 'The assignment is not found.',
  'creator-assignment.view': 'View',
  'creator-assignment.submissions': 'Submissions',

  // Assignment View Content
  'assignment-view-content.deadline': 'Deadline:',
  'assignment-view-content.assignment-content': 'Assignment Content:',

  // Submissions
  'submissions.fetching': 'Getting submissions...',
  'submissions.breadcrumb-submission': 'Submissions',
  'submissions.students-on-time': 'Students Who Submitted On Time',
  'submissions.no-submissions-label':
    'There are currently no submissions for this category.',
  'submissions.students-late': 'Students Who Submitted Late',
  'submissions.students-no-submissions': 'Students With No Submissions Yet',
  'submissions.view-submission': 'View Submission',
  'submissions.user-no-submission': 'No submission yet for this user',

  // Submission View
  'assignment-submission.forbidden': 'You are forbidden to perform further actions.',
  'assignment-submission.not-exist':
    'This submission cannot be found. It might be deleted.',
  'assignment-submission.breadcrumb-submission-of': 'Submission of',
  'assignment-submission.breadcrumb-your-submission': 'Your Submission',
  'assignment-submission.submitter-info': 'Submitter Info:',
  'assignment-submission.status': 'Status:',
  'assignment-submission.status-returned': 'Returned',
  'assignment-submission.status-on-time': 'Submitted On Time',
  'assignment-submission.status-late': 'Submitted Late',
  'assignment-submission.score': 'Score:',
  'assignment-submission.edit-mark': 'Edit Mark',
  'assignment-submission.give-mark': 'Give Mark',
  'assignment-submission.submission-content': 'Submission Content:',
  'assignment-submission.edit-submit-tooltip': 'Edit Submission',
  'assignment-submission.delete-submit-tooltip': 'Delete Submission',
  'assignment-submission.title-assurance-delete':
    'Are you sure to delete your submission?',
  'assignment-submission.warn-before-delete':
    "This action is irrevocable. You won't be able to retrieve this submission in the future.",
  'assignment-submission.given-score': 'Given Score',
  'assignment-submission.total': 'Total',
  'assignment-submission.give-score-title': 'Give Score',
  'assignment-submission.give-score-guide':
    'Make sure to give equal total scores in this activity for all submissions.',
  'assignment-submission.updating-changes': 'Updating changes to your submission',
  'assignment-submission.edited-changes': 'Your submission has been successfully edited!',
  'assignment-submission.deleted-changes':
    'Your submission has been successfully deleted!',
  'assignment-submission.saving-score': "Saving student's score",
  'assignment-submission.saved-score': "Student's score has been successfully posted.",
  'assignment-submission.view-my-submission': 'View My Submission',
  'assignment-submission.add-submission': 'Add Submission',
  'assignment-submission.turning-in': 'Turning your submission in...',
  'assignment-submission.turned-in': 'Your assignment has been turned in!',
  'given-score.cannot-exceed-total': 'Given score cannot exceed total score.',
  'total-score.cannot-exceed-100': 'Total score cannot exceed 100.',
  'given-score.cannot-be-zero': 'Given score cannot be zero.',
  'total-score.cannot-be-zero': 'Total score cannot be zero.',

  // Chat
  'user-info-dialog': 'User Info',
  'chat.send-message-label': 'Your Message',
  'chat.send-message-error': 'Message should contain between 1 - 1024 characters only.',
  'chat.fetching-messages': 'Getting list of messages',
  'chat.classroom-chat-main': 'Classroom Chat',
  'chat.report-chat': 'Report Chat',
  'chat.messages-label': 'Messages',
  'chat.personal-message': 'Personal Message',
  'chat.added-all-users': 'You have added all allowed users.',
  'chat.user-added': 'The user has been added.',
  'main-chat.not-exist': 'The classroom main chat is not found. Please refresh the page.',
  'sub-chat.exists-already':
    'A chat box with this user has already been created. Please refresh the page to see latest changes.',
  'chat-sending.failed': 'An error occurred while sending your message.',
  'chat.popper-view-user': 'View User Info',
  'chat.popper-report-user': 'Report User',
  'chat.ago': 'ago',
  'chat.conversation-not-started':
    'Conversation not started yet with this user. Why not start one?',
  'chat.conversation-not-started-main': 'No conversation started yet.',
  'chat.view-more': 'View More',

  // Events
  'events.event-form-button-agree': 'Create',
  'events.event-form-title-dialogue': 'Event Creation Form',
  'events.event-form-title': 'Event Title',
  'events.event-form-desc': 'Event Description',
  'events.event-form-title-error':
    'Event title should contain between 1 - 128 characters.',
  'events.event-form-start': 'Event Start Date',
  'events.event-form-start-error': 'Enter a valid starting date.',
  'events.event-form-start-error-past': 'Start date cannot be in the past.',
  'events.event-form-end': 'Event End Date',
  'events.event-form-end-not-a-number': 'Enter a valid ending date.',
  'events.event-form-end-recedes-start': 'End date cannot happen past the starting date.',
  'events.fetching': 'Getting list of events',
  'events.event-created': 'The event has been created!',
  'events.event-more-details': 'Event Details',
  'events.event-edited': 'The event has been edited!',
  'events.event-form-create-button': 'Create',
  'events.event-form-edit-button': 'Edit',
  'events.title-assurance-delete': 'Are you sure to delete the event?',
  'events.warn-before-delete':
    "This action is irrevocable. You won't be able to retrieve this event in the future.",
  'events.event-deleted': 'The event has been removed!',

  // Classroom Settings
  'classroom-settings.settings': 'Classroom Settings',
  'classroom-settings.resuming-warning':
    'Classroom has already ended. Trying to resume the classroom will fail if you already have 3 ongoing classrooms.',
  'classroom-settings.resume-btn': 'Resume Classroom',
  'classroom-settings.title-label': 'Classroom Title',
  'classroom-settings.set-as-completed': 'Set Classroom as Completed',
  'classroom-settings.re-input': 'Re-input classroom title to proceed',
  'classroom-settings.end-btn': 'End Classroom',
  'classroom-settings.students-enrolled': 'Students Enrolled:',
  'classroom-settings.start-btn': 'Start Manually',
  'classroom-settings.start-helper':
    'Once the number of enrollees reaches 1 or more, you can start the classroom manually.',
  'classroom-settings.starting': 'Starting classroom',
  'classroom-settings.force-starting':
    'Force restarting page once the process is done...',
  'classroom-me.go-back': 'Go Back',
  'classroom-me.checkpoint': 'Checkpoint Along the Way. Please Stop!',
  'classroom-me.off-limits-highlight': 'This place is off limits!',
  'classroom-me.off-limits': 'You might be lost. Please take a step back.',
  'classroom-me.classroom-yet-to-start': 'Classroom is yet to start.',
  'classroom-me.number-of-enrolless': 'Number of Enrollees:',
  'classroom-me.no-student':
    'Start timer has already ended but the classroom has no student enrolled.',
  'classroom-me.classroom-deleted':
    'This classroom will be deleted automatically within the day. Sorry for the inconvenience.',
};
